import config from "../Config/config";

const fetchActivities = async (setActivities) => {
  await fetch(`${config.serverBaseUrl}/activity`, { credentials: "include" })
    .then((res) => res.json())
    .then((resJson) => setActivities(resJson.data.activities));
};

const saveActivity = async (
  selectedActivity,
  setIsEditing,
  setAlert,
  setActivities
) => {
  const method = selectedActivity.activity_id ? "PUT" : "POST";
  const url = selectedActivity.activity_id
    ? `${config.serverBaseUrl}/activity/${selectedActivity.activity_id}`
    : `${config.serverBaseUrl}/activity`;

  try {
    const response = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(selectedActivity),
    });

    if (response.ok) {
      setIsEditing(false);
      fetchActivities(setActivities);
      setAlert({
        severity: "success",
        message: "Activity saved!",
      });
    } else {
      const data = await response.json();
      const error = data.error;
      setAlert({
        severity: "error",
        message: `Failed to save the activity: ${error}`,
      });
    }
  } catch (error) {
    setAlert({
      severity: "error",
      message: `Failed to save the activity: ${error}`,
    });
  }
};

const deleteActivity = async (id, setActivities, setAlert) => {
  try {
    const response = await fetch(`${config.serverBaseUrl}/activity/${id}`, {
      method: "DELETE",
      credentials: "include",
    });
    if (response.ok) {
      fetchActivities(setActivities);
      setAlert({
        severity: "success",
        message: `Activity deleted!`,
      });
    } else {
      const data = await response.json();
      const error = data.error;
      setAlert({
        severity: "error",
        message: `Failed to delete the activity: ${error}`,
      });
    }
  } catch (error) {
    setAlert({
      severity: "error",
      message: `Failed to delete the activity: ${error}`,
    });
  }
};

export { fetchActivities, saveActivity, deleteActivity };
